import { format } from "date-fns";
import { Calendar16Regular as CalendarIcon } from "@fluentui/react-icons";
import * as React from "react";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface DatePickerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  value?: Date | null;
  error?: string;
  onDateChange: (date?: Date) => void;
}

function DatePicker({
  className,
  value,
  error,
  onDateChange: setDate,
}: DatePickerProps) {
  const { t } = useTranslation();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[280px] justify-start text-left font-normal",
            !value && "text-muted-foreground",
            className,
          )}
        >
          <CalendarIcon className="mr-2" />
          {value ? (
            format(value, t("date-format"))
          ) : (
            <span>{t("pick-a-date")}</span>
          )}
        </Button>
      </PopoverTrigger>
      {error && <p className="text-red-500">{error}</p>}
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={value === null ? undefined : value}
          onSelect={setDate}
        />
      </PopoverContent>
    </Popover>
  );
}

export default DatePicker;
